import React, {useEffect, useState} from 'react';
import Navbar from "../parts/Navbar";
import Sidebar from "../parts/Sidebar";
import ControlSidebar from "../parts/ControlSidebar";
import Dashboard from "../parts/Dashboard";
import Header from "../parts/Header";
import Menu from "../parts/Menu";
import Footer from "../parts/Footer";


const DashboardPage = () => {
    return (
        <div className="wrapper">
            <Navbar/>
            <Sidebar/>
            <ControlSidebar/>
            <Dashboard/>
            <Header/>
            <Menu/>
            <Footer/>
        </div>
    );
};

export default DashboardPage;
